import { createContext } from "react"
import { ProducContextProps } from "../interfaces/product.interface"

export const ProductContext = createContext({} as ProducContextProps)
export const { Provider } = ProductContext

